// extracted by mini-css-extract-plugin
module.exports = {"container":"_2P_mtd mz-price-breakdown__item zmNIBl","label":"_2ZDJOc"};